import { useContext, useState } from 'react'

import GovernanceProjectNameDpoContext from 'contexts/GovernanceProjectNameDpoContext'

const useGovernanceProjectNameDpo = () => {
  const context = useContext(GovernanceProjectNameDpoContext)
  const [dpoKind, setDpoKind] = useState()

  if (context === undefined) {
    throw new Error(
      'useGovernanceProjectNameDpo must be used within a GovernanceProjectNameDpoContext.Provider',
    )
  }

  return {
    loading: context.loading,
    setLoading: context.setLoading,
    governanceProjectTemplate: context.governanceProjectTemplate,
    setGovernanceProjectTemplate: context.setGovernanceProjectTemplate,
    loadGovernanceProjectTemplate: context.loadGovernanceProjectTemplate,
    governanceProjectCompany: context.governanceProjectCompany,
    loadGovernanceProjectCompany: context.loadGovernanceProjectCompany,
    principalDpo: context.principalDpo,
    setPrincipalDpo: context.setPrincipalDpo,
    substituteDpo: context.substituteDpo,
    setSubstituteDpo: context.setSubstituteDpo,
    dpoKind: dpoKind || context.principalDpo?.kind,
    setDpoKind,
    recaptcha: context.recaptcha,
    recaptchaRef: context.recaptchaRef,
    handleAcceptedRecaptcha: context.handleAcceptedRecaptcha,
    disableRecaptcha: context.disableRecaptcha,
    resetRecaptcha: context.resetRecaptcha,
  }
}

export default useGovernanceProjectNameDpo
